// Massage.js
import React, { useEffect } from 'react';
import './Massage.css';

const Massage = ({ message, clearError, type = 'error' }) => {

    useEffect(() => {
        const timer = setTimeout(() => {
            clearError(); // parent must pass this function
        }, 5000);

        return () => clearTimeout(timer);
    }, [message]);


    return (
        <div className={`message__box ${type}`}>
            <p className="error-text">{message}</p>
        </div>
    );
};

export default Massage;
